import { render, staticRenderFns } from "./AddExample.vue?vue&type=template&id=35ec0988&scoped=true"
import script from "./AddExample.vue?vue&type=script&lang=js"
export * from "./AddExample.vue?vue&type=script&lang=js"
import style0 from "./AddExample.vue?vue&type=style&index=0&id=35ec0988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec0988",
  null
  
)

export default component.exports